import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ManagedLoginService {
  constructor(private http: HttpClient) {}

  login() {
    window.location.href =
      `${environment.cognitoDomain}/login/continue` +
      `?client_id=${environment.cognito.userPoolWebClientId}` +
      `&redirect_uri=${this.getRedirectUri()}` +
      '&response_type=code' +
      '&scope=email openid phone profile';
  }

  getRedirectUri(): string {
    return environment.isLocal
      ? 'http://localhost:4200/callback'
      : environment.appEnv == 'prod'
      ? 'https://financials.explorandes.app/callback'
      : 'https://financialsdev.explorandes.app/callback';
  }

  signOut() {
    localStorage.clear();
    this.login();
  }

  getCognitoToken(code: string) {
    const clientId = environment.cognito.userPoolWebClientId;
    const tokenUrl = `${environment.cognitoDomain}/oauth2/token`;

    const body = new HttpParams()
      .set('grant_type', 'authorization_code')
      .set('client_id', clientId)
      .set('redirect_uri', this.getRedirectUri())
      .set('code', code);

    return this.http.post(tokenUrl, body.toString(), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  async refreshToken() {
    const clientId = environment.cognito.userPoolWebClientId;
    const tokenUrl = `${environment.cognitoDomain}/oauth2/token`;
    const refreshToken = localStorage.getItem('refresh_token');

    if (!refreshToken) {
      console.error('No refresh token available, user must log in again');
      this.signOut();
      return;
    }

    const body = new HttpParams()
      .set('grant_type', 'refresh_token')
      .set('client_id', clientId)
      .set('refresh_token', refreshToken);

    try {
      // Usamos await para esperar que se complete la llamada HTTP antes de continuar
      const response: any = await this.http
        .post(tokenUrl, body.toString(), {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        })
        .toPromise();

      // Si la respuesta es exitosa, guardamos los tokens
      localStorage.setItem('access_token', response.access_token);
      localStorage.setItem('id_token', response.id_token);

      // Llamamos a la función para programar la actualización del token
      this.scheduleTokenRefresh();
    } catch (error: any) {
      console.error('Error refreshing token:', error);
      if (error.status === 400) {
        console.warn('Refresh token expired, logging out user');
        this.signOut();
      }
    }
  }

  decodeToken(): any {
    const idToken = localStorage.getItem('id_token');
    if (!idToken) {
      return null;
    }

    try {
      const decodedToken: any = jwtDecode(idToken);
      return decodedToken;
    } catch (error) {
      console.error('Error al decodificar el token:', error);
      return null;
    }
  }

  scheduleTokenRefresh() {
    const decoded = this.decodeToken();
    const expiresInMs = decoded.exp * 1000 - Date.now() - 5 * 60 * 1000; // 5 min antes de expirar

    setTimeout(() => {
      this.refreshToken();
    }, expiresInMs);
  }

  isTokenExpired(): boolean {
    const decoded = this.decodeToken();
    return decoded.exp * 1000 < Date.now();
  }
}
